'use client'

import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import React, { createContext, useCallback, useState } from 'react'

import CMSButton from '~/components/button/cms'
import { IFormModal } from '~/types/form'
import { IStrapiButton } from '~/types/strapi'

const ContentLayout = dynamic(() => import('./contact-modals-content'), {
  ssr: false,
})

interface IContactContext {
  isOpened: boolean
  open: () => void
}

interface Props {
  modal: IFormModal
  buttonPosition: 'left' | 'right'
  openButton: IStrapiButton
}

const initialState: Partial<IContactContext> = {
  isOpened: false,
}

export const ContactContext = createContext<IContactContext>(
  initialState as IContactContext
)

const ContactProvider: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  buttonPosition,
  modal,
  openButton,
}) => {
  const [isOpened, setIsOpened] = useState(false)
  const pathname = usePathname()

  const open = useCallback(() => {
    setIsOpened(true)
  }, [])

  const shouldShowButton = !pathname.startsWith('/getbraza')

  return (
    <ContactContext.Provider
      value={{
        isOpened,
        open,
      }}
    >
      {children}
      {modal && modal.ukForm && shouldShowButton && (
        <div>
          <div
            className={classNames('hidden md:flex fixed bottom-[5%] z-50', {
              'left-[5%]': buttonPosition === 'left',
              'right-[5%]': buttonPosition === 'right',
            })}
          >
            <CMSButton tiny attributes={openButton} onClick={() => open()} />
          </div>
          <ContentLayout
            formModal={modal}
            isOpened={isOpened}
            onClose={() => setIsOpened(false)}
          />
        </div>
      )}
    </ContactContext.Provider>
  )
}

export function useContactModal() {
  return React.useContext(ContactContext)
}

export default ContactProvider
